import * as React from 'react';
import cx from 'classnames';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select as MuiSelect } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import css from './Select.module.scss';

type TSelect = {
  placeholder?: string;
  label?: string;
  value: string;
  options: {
    value: string;
    label: string;
  }[];
  disabled?: boolean;
  width?: number;
  onChange: (event: SelectChangeEvent) => void; 
}

export const Select = ({ placeholder, label, options, onChange, value, disabled = false, width }: TSelect) => {
  const [isFocused, setIsFocused] = React.useState(false);
  
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      {label && <div className={css.label}>{label}</div>}
      {placeholder && <InputLabel className={cx(css.placeholder, (isFocused || value) && css.isFocused)}>{placeholder}</InputLabel>}
      <MuiSelect
        sx={{ width: width ? `${width}px` : undefined }}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
      >
        {options.map(item => (
          <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
}